import { colorsPalettes } from "@similarweb/styles";

import type { IStepScreenProps } from "app/components/ChangeSolutionModal/types";
import I18n, { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { AssetsService } from "app/services/AssetsService";

import { StyledScreenWrapper, StyledScreenTitle, StyledRobotIllustration, StyledScreenDescription } from "../styles";

const { carbon } = colorsPalettes;

export const WelcomeScreen = ({ config }: IStepScreenProps) => {
    const translate = useTranslation();
    return (
        <StyledScreenWrapper>
            <StyledScreenTitle
                fontVariant="h3"
                color={carbon[500]}
            >
                {translate(config.title)}
            </StyledScreenTitle>
            <StyledScreenDescription
                fontVariant="h6"
                color={carbon[400]}
            >
                <I18n dangerouslySetInnerHTML>{translate(config.subTitle)}</I18n>
            </StyledScreenDescription>
            <StyledRobotIllustration>
                <img src={AssetsService.assetUrl("/images/swicons/switch-solution-welcome.svg")} />
            </StyledRobotIllustration>
        </StyledScreenWrapper>
    );
};
